import { Spinner } from "@chakra-ui/react";
import { Button } from "newui/components/Button";
import { Icon } from "assets/Icon";

export const SmartFieldCardButtons = ({
	rfqSubmission,
	selected,
	selectHandler,
	isLoading,
	editHandler,
	editLabel,
	isPreview,
	viewHandler,
	supplierSmartField,
	dataTestId,
	buttonClassName,
}) => (
	<div className="flex gap-3">
		{rfqSubmission && !isPreview && (
			<>
				<Button
					type="button"
					btntype={selected ? "primary" : "secondary"}
					className={buttonClassName || "!w-full items-center gap-1.5"}
					onClick={selectHandler}
					data-testid={dataTestId}
					disabled={isLoading}
				>
					{isLoading ? (
						<Spinner size="sm" />
					) : (
						<>
							{selected ? "Selected" : "Select"}
							{selected && (
								<Icon
									icon="check-only"
									width={20}
									height={20}
								/>
							)}
						</>
					)}
				</Button>
				<Button
					btntype="secondary"
					className={supplierSmartField ? "w-[42px]" : "!w-full"}
					onClick={editHandler}
				>
					{supplierSmartField ? <Icon icon="pencil-02" /> : `Open ${editLabel}`}
				</Button>
			</>
		)}
		{isPreview && (
			<Button
				btntype="secondary"
				className="!w-full"
				type="button"
				onClick={viewHandler}
			>
				View {editLabel}
			</Button>
		)}
	</div>
);
